export default __webpack_public_path__ + "static/media/M35.424f2536.svg";